import axios from 'axios';

let baseURL;

// Determine if the code is running on the server or client
const IS_SERVER = typeof window === 'undefined';
if (IS_SERVER) {
  // On the server, use the full backend URL from environment variables
  // This is for when apiClient might be used directly in server/index.js for data pre-fetching
  baseURL = process.env.BACKEND_BASE_URL;
  if (!baseURL) {
    console.warn(
      'BACKEND_BASE_URL is not set for server-side apiClient. This might be an issue if apiClient is used server-side.'
    );
  }
} else {
  // On the client, always use a relative path to go through the proxy on the frontend server
  baseURL = '/api';
}


const apiClient = axios.create({
  baseURL: baseURL,
  validateStatus: function (status) {
    return status >= 200 && status < 500; // default
  }
});

// Add request interceptor to ensure auth token is included
apiClient.interceptors.request.use(
  (config) => {
    // Get token from localStorage if it's not already in headers
    if (!config.headers.Authorization) {
      const token = localStorage.getItem('jwt_token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle token expiration
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid, clear storage and redirect to login
      localStorage.removeItem('jwt_token');
      localStorage.removeItem('user_data');
      // Only redirect if not already on login page
      if (window.location.pathname !== '/') {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

// You can add interceptors here if needed (e.g., for auth tokens)

export const listDirectory = async (path = '.') => {
  try {
    const response = await apiClient.get('/directory/list-directory', {
      params: { path },
    });
    return response.data;
  } catch (error) {
    console.error('Error listing directory:', error);
    throw error;
  }
};

export const getDirectoryTree = async () => {
  try {
    const response = await apiClient.get('/directory/get-directory-tree');
    return response.data;
  } catch (error) {
    console.error('Error fetching directory tree:', error);
    throw error;
  }
};

export default apiClient;
